import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconClose, IconGreenEllipse, IconYellowEllipse, IconRedEllipse } from "./icons";
import { QuickSettingsContainer, MenuItem, ButtonV2, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorBodyWrapper, MenuColorLabel, MenuActionContainer, MenuActionItem } from "./layout.c";

interface PrinterItem {
    _id: string;
    name: string;
    disabled?: boolean;
    api_key?: string;
}

interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave?: () => void;
    title?: string;
    onClickPrinter?: (printer: PrinterItem) => void;
}

@inject("store") @observer
class MenuPrinterSettingsClass extends MobxComponent<Props, {}> {
    render() {
        const { store } = this.injected;
        const { show, onHide, title, onClickPrinter } = this.props;
        const r = store.restaurant;
        const printers: PrinterItem[] = (r?.settings?.printers ?? []) as PrinterItem[];
        const activePrinters: string[] = store.ably?.printers ?? [];

        return (
            <QuickSettingsContainer className={show ? 'active' : ''}>
                <MenuColorHeaderWrapper>
                    <MenuColorHeaderTitleWrapper>
                        {title || 'Printer Setup'}
                    </MenuColorHeaderTitleWrapper>
                    <MenuItem onClick={onHide}><IconClose /></MenuItem>
                </MenuColorHeaderWrapper>
                <MenuColorBodyWrapper style={{ minHeight: '50vh', overflowY: 'scroll' }}>
                    <MenuColorLabel>Select printer</MenuColorLabel>
                    <MenuActionContainer>
                        {printers.length === 0 ? (
                            <p style={{ padding: 16, color: '#6B7270' }}>No printers configured. Add printers in Settings.</p>
                        ) : (
                            printers.map((printer) => {
                                const isConnected = !printer.disabled && (printer.api_key ? activePrinters.indexOf(printer.api_key) !== -1 : false);
                                const isIssue = !printer.disabled && !isConnected && !!printer.api_key;
                                return (
                                    <MenuActionItem
                                        key={printer._id}
                                        onClick={() => onClickPrinter?.(printer)}
                                        className="menu-printer-item"
                                    >
                                        {printer.name}
                                        <span>
                                            {isConnected && <><IconGreenEllipse /> Connected</>}
                                            {isIssue && <><IconYellowEllipse /> Disconnected</>}
                                            {printer.disabled && <><IconRedEllipse /> Disabled</>}
                                            {!isConnected && !isIssue && !printer.disabled && <><IconRedEllipse /> Disconnected</>}
                                        </span>
                                    </MenuActionItem>
                                );
                            })
                        )}
                    </MenuActionContainer>
                </MenuColorBodyWrapper>
            </QuickSettingsContainer>
        );
    }
}
export const MenuPrinterSettings = withTranslation()(MenuPrinterSettingsClass);
